import { Component, OnDestroy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { APPLICATION_ROUTES } from '../../../constants/application-routes';
import { resetGrantRevokePermissionState } from '../../../store/actions/grant-revoke-permissions.action';

import { selectRemoveUserStepperSelectedUser } from '../../../store/selectors/grant-revoke-permissions.selector';
import accountPermissionUtils from '../../../utils/account-permission/account-permission.util';
import { ContentUtil } from '../../../utils/content/content.util';
import { AdobeTagging } from '../../../utils/decorators/dev/adobe-launch';
import { adobeConfigData } from './remove-user-confirmation-page-adobe';
import { AsyncPipe } from '@angular/common';
import { ButtonModule } from '@vg-constellation/angular-20/button';
import { IconModule } from '@vg-constellation/angular-20/icon';
import { ReplaceParamPipe } from '../../../pipes/replace-param/replace-param.pipe';

@AdobeTagging(adobeConfigData)
@Component({
    selector: 'zci-remove-user-confirmation-page',
    templateUrl: './remove-user-confirmation-page.component.html',
    styleUrls: ['./remove-user-confirmation-page.component.scss'],
    imports: [
        AsyncPipe,
        IconModule,
        ButtonModule,
        ReplaceParamPipe,
    ],
})
export class RemoveUserConfirmationPageComponent implements OnDestroy {
    private readonly store = inject(Store);
    private readonly router = inject(Router);

    constructUserName = accountPermissionUtils.constructUserName;

    content = ContentUtil.content;
    myAccountsUrl: string;

    selectedUserName$: Observable<string> = this.store
        .select(selectRemoveUserStepperSelectedUser)
        .pipe(map(this.constructUserName));

    navigateToMyAccounts(): void {
        this.router.navigateByUrl(APPLICATION_ROUTES.OWN_ACCOUNTS);
    }

    ngOnDestroy(): void {
        this.store.dispatch(resetGrantRevokePermissionState());
    }
}
